var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Box, Button, Tooltip, Typography, useTheme } from '@mui/material';
import { Link05Icon, Unlink05Icon } from 'hugeicons-react';
import { useMemo, useRef, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { AppConsts } from '../../../../application/common/constants/app-consts';
import { RoleCategories } from '../../../../application/common/constants/role-categories';
import { getFilteredStringOperators } from '../../../../application/common/helpers/grid-filter-operators';
import { useGetAllCompaniesQuery } from '../../../../application/features/companies/company-api';
import { useGetMachineBrandListQuery, useGetMachinesListQuery, useGetPaginatedMachineLibraryQuery } from '../../../../application/features/machines/machine-api';
import { useAppSelector } from '../../../../application/store/useStore';
import useTranslate from '../../../../localization/helpers';
import ProtectedElement from '../../../components/ProtectedElement';
import TableClickableItem from '../../../components/tableClickableItem';
import { Permissions } from '../../../permissions';
import LinkToMachineDialog from './link-to-machine-dialog';
import MachineLibraryCard from './machine-library-card';
import MachineLibraryDialog from './machine-library-dialog';
import MachineLibraryGrid from './machine-library-grid';
var MachineLibrary = function (_a) {
    var _b;
    var isscreen600900 = _a.isscreen600900, iscreen9001200 = _a.iscreen9001200, isXs = _a.isXs, isscreen600900Landscape = _a.isscreen600900Landscape, isscreen9001200Landscape = _a.isscreen9001200Landscape, isScreen9001200 = _a.isScreen9001200, isSm = _a.isSm, isLg = _a.isLg, isMd = _a.isMd, isIpadMini = _a.isIpadMini, isIpadMiniLandscape = _a.isIpadMiniLandscape, openFilterDrawer = _a.openFilterDrawer, setOpenFilterDrawer = _a.setOpenFilterDrawer;
    var theme = useTheme();
    var navigate = useNavigate();
    var currentUser = useAppSelector(function (state) { return state.auth; }).currentUser;
    var isSuperAdmin = (currentUser === null || currentUser === void 0 ? void 0 : currentUser.roleCategory) === RoleCategories.SuperAdmin;
    var _c = __read(useState(false), 2), dialogOpen = _c[0], setDialogOpen = _c[1];
    var _d = __read(useState(), 2), selectedRow = _d[0], setSelectedRow = _d[1];
    var translate = useTranslate().translate;
    var _e = __read(useSearchParams(), 1), searchParams = _e[0];
    var _f = __read(useState(false), 2), documentDialogOpen = _f[0], setDocumentDialogOpen = _f[1];
    var _g = __read(useState(null), 2), selectedMachineId = _g[0], setSelectedMachineId = _g[1];
    var _h = __read(useState(null), 2), openTooltipId = _h[0], setOpenTooltipId = _h[1];
    var onManageSerialNumbers = function (machineId) {
        return navigate("/assets/asset-library-details/".concat(machineId));
    };
    var id = searchParams.get('id');
    var _j = __read(useState({
        id: id !== null && id !== void 0 ? id : undefined,
        machines: [],
        brands: [],
        companies: [],
        filterField: undefined,
        filterOperator: undefined,
        filterValue: undefined,
        sortField: AppConsts.DEFAULT_SORT_FIELD,
        sortDirection: AppConsts.DEFAULT_SORT_DIRECTION,
        page: AppConsts.DEFAULT_PAGE_NUMBER,
        pageSize: AppConsts.DEFAULT_PAGE_SIZE
    }), 2), machineFilters = _j[0], setMachineFilters = _j[1];
    var _k = useForm({
        defaultValues: {
            machines: [],
            brands: [],
            companies: [],
            filterField: undefined,
            filterOperator: undefined,
            filterValue: undefined,
            sortField: AppConsts.DEFAULT_SORT_FIELD,
            sortDirection: AppConsts.DEFAULT_SORT_DIRECTION,
            page: AppConsts.DEFAULT_PAGE_NUMBER,
            pageSize: AppConsts.DEFAULT_PAGE_SIZE
        }
    }), control = _k.control, handleSubmit = _k.handleSubmit, reset = _k.reset, errors = _k.formState.errors;
    var _l = useGetAllCompaniesQuery({
        filterByCompany: false
    }), _m = _l.data, companiesList = _m === void 0 ? [] : _m, isCompaniesFetching = _l.isFetching;
    var _o = useGetMachinesListQuery({
        filterByCompany: false,
        isMachineLibrary: true
    }), _p = _o.data, machinesList = _p === void 0 ? [] : _p, isMachinesFetching = _o.isFetching;
    var _q = useGetMachineBrandListQuery({
        filterByCompany: false
    }), _r = _q.data, machinesBrandList = _r === void 0 ? [] : _r, isBrandsFetching = _q.isFetching;
    var _s = useGetPaginatedMachineLibraryQuery(machineFilters, {
        refetchOnMountOrArgChange: true
    }), paginatedMachines = _s.data, isPaginatedMachinesFetching = _s.isFetching, isPaginatedMachinesLoading = _s.isLoading;
    var machines = (paginatedMachines === null || paginatedMachines === void 0 ? void 0 : paginatedMachines.items) || [];
    var rowCountRef = useRef((_b = paginatedMachines === null || paginatedMachines === void 0 ? void 0 : paginatedMachines.totalCount) !== null && _b !== void 0 ? _b : 0);
    var rowCount = useMemo(function () {
        if ((paginatedMachines === null || paginatedMachines === void 0 ? void 0 : paginatedMachines.totalCount) !== undefined) {
            rowCountRef.current = paginatedMachines === null || paginatedMachines === void 0 ? void 0 : paginatedMachines.totalCount;
        }
        return rowCountRef.current;
    }, [paginatedMachines]);
    var onSearch = function (searchTerm) {
        var filterArg = __assign(__assign({}, searchTerm), { sortField: machineFilters.sortField, sortDirection: machineFilters.sortDirection, page: machineFilters.page, pageSize: machineFilters.pageSize, companies: searchTerm.companies, brands: searchTerm.brands, machines: searchTerm.machines });
        setMachineFilters(filterArg);
    };
    var handleOpenDialog = function (row) {
        setSelectedRow(row);
        setDialogOpen(true);
    };
    var handleFilterModelChange = function (model) {
        if (model.items.length > 0) {
            var filterItem_1 = model.items[0];
            if (filterItem_1.operator !== 'isEmpty' &&
                filterItem_1.operator !== 'isNotEmpty' &&
                (filterItem_1.value === '' ||
                    (Array.isArray(filterItem_1.value) && filterItem_1.value.length === 0) ||
                    filterItem_1.value === undefined)) {
                setMachineFilters(function (prev) { return (__assign(__assign({}, prev), { filterField: undefined, filterOperator: undefined, filterValue: undefined })); });
            }
            else {
                setMachineFilters(function (prev) {
                    var _a;
                    return (__assign(__assign({}, prev), { filterField: filterItem_1.field, filterOperator: filterItem_1.operator, filterValue: (_a = filterItem_1.value) === null || _a === void 0 ? void 0 : _a.toString() }));
                });
            }
        }
        else {
            // When model.items is empty, clear all filters
            setMachineFilters(function (prev) { return (__assign(__assign({}, prev), { filterField: undefined, filterOperator: undefined, filterValue: undefined })); });
        }
        setFilterModel(model);
    };
    var _t = __read(useState({
        items: []
    }), 2), filterModel = _t[0], setFilterModel = _t[1];
    var handlePaginationModelChange = function (model) {
        setMachineFilters(function (prev) { return (__assign(__assign({}, prev), { page: model.page + 1, pageSize: model.pageSize })); });
    };
    var handleSortModelChange = function (model) {
        setMachineFilters(function (prev) {
            var _a, _b, _c, _d;
            return (__assign(__assign({}, prev), { sortField: (_b = (_a = model[0]) === null || _a === void 0 ? void 0 : _a.field) !== null && _b !== void 0 ? _b : AppConsts.DEFAULT_SORT_FIELD, sortDirection: (_d = (_c = model[0]) === null || _c === void 0 ? void 0 : _c.sort) !== null && _d !== void 0 ? _d : AppConsts.DEFAULT_SORT_DIRECTION }));
        });
    };
    var columns = [
        {
            field: 'isLinked',
            headerName: translate('assets.matchingAssets.linked') + '?',
            flex: 0.5,
            minWidth: isXs ? 150 : isscreen600900 ? 150 : isMd ? 150 : undefined,
            sortable: false,
            filterable: false,
            disableColumnMenu: true,
            renderHeader: function () { return (_jsx(Box, { display: 'flex', alignItems: 'center', gap: 0.5, children: _jsx(Link05Icon, { width: 24, height: 24 }) })); },
            renderCell: function (params) {
                return (_jsx(_Fragment, { children: params.row.linkedTo.length > 0 && (_jsx(Box, { display: 'flex', flexShrink: 0, alignItems: 'center', height: '100%', sx: { cursor: 'pointer' }, children: _jsx(Tooltip, { arrow: true, placement: 'right', open: openTooltipId === params.row.id, onOpen: function () { return setOpenTooltipId(params.row.id); }, onClose: function () { return setOpenTooltipId(null); }, slotProps: {
                                popper: { disablePortal: false }
                            }, title: _jsx(Box, { maxHeight: '150px', sx: { overflowY: 'auto' }, children: params.row.linkedTo
                                    .filter(function (item, index, self) {
                                    return index ===
                                        self.findIndex(function (t) {
                                            return t.companyName === item.companyName &&
                                                t.modelNumber === item.modelNumber &&
                                                t.machineName === item.machineName;
                                        });
                                })
                                    .map(function (l, i, arr) { return (_jsxs(Box, { sx: {
                                        p: 1,
                                        color: 'white',
                                        minWidth: 180,
                                        borderBottom: i < arr.length - 1 ? '2px solid #919EAB33' : 'none'
                                    }, children: [_jsx(Box, { width: '20px', height: '20px', display: 'flex', justifyContent: 'center', alignItems: 'center', borderRadius: '500px', bgcolor: theme.palette.grey[300], color: theme.palette.grey[800], mb: 0.5, children: _jsx(Typography, { variant: 'body2', fontWeight: 600, children: i + 1 }) }), _jsxs(Box, { sx: { display: 'flex', flexDirection: 'column', gap: '4px' }, children: [_jsxs(Box, { sx: { display: 'flex', gap: 1 }, children: [_jsx(Typography, { variant: 'caption', sx: { color: '#C4CDD5' }, children: translate('common.asset') + ':' }), _jsx(Typography, { variant: 'caption', sx: { color: '#FFFFFF' }, children: l.machineName })] }), isSuperAdmin && (_jsxs(Box, { sx: { display: 'flex', gap: 1 }, children: [_jsx(Typography, { variant: 'caption', sx: { color: '#C4CDD5' }, children: translate('common.company') + ':' }), _jsx(Typography, { variant: 'caption', sx: { color: '#FFFFFF' }, children: l.companyName })] })), _jsxs(Box, { sx: { display: 'flex', gap: 1 }, children: [_jsx(Typography, { variant: 'caption', sx: { color: '#C4CDD5' }, children: translate('assets.matchingAssets.model') + '#:' }), _jsx(Typography, { variant: 'caption', sx: { color: '#FFFFFF' }, children: l.modelNumber })] })] })] }, i)); }) }), children: _jsx(Link05Icon, { width: 24, height: 24 }) }) })) }));
            }
        },
        {
            field: 'name',
            headerName: translate('common.asset'),
            flex: 1.5,
            minWidth: isXs ? 150 : isscreen600900 ? 400 : isMd ? 150 : undefined,
            filterOperators: getFilteredStringOperators()
        },
        {
            field: 'type',
            headerName: translate('assets.type'),
            flex: 1,
            minWidth: isXs ? 150 : isscreen600900 ? 400 : isMd ? 150 : undefined,
            filterOperators: getFilteredStringOperators()
        },
        {
            field: 'brand',
            headerName: translate('assets.brand'),
            flex: 1,
            minWidth: isXs ? 150 : isscreen600900 ? 400 : isMd ? 150 : undefined,
            filterOperators: getFilteredStringOperators()
        },
        {
            field: 'totalModelNumbers',
            headerName: translate('assets.models'),
            sortable: false,
            filterable: false,
            disableColumnMenu: true,
            flex: 1,
            minWidth: isXs ? 150 : isscreen600900 ? 200 : isMd ? 150 : undefined,
            renderCell: function (params) { return (_jsx(Box, { my: 1.5, display: 'flex', alignItems: 'center', gap: 2, children: _jsx(TableClickableItem, { text: params.row.totalModelNumbers, onClick: function () { return onManageSerialNumbers(params.row.id); } }) })); }
        },
        {
            field: 'documents',
            sortable: false,
            filterable: false,
            disableColumnMenu: true,
            headerName: translate('common.documents'),
            flex: 1,
            minWidth: isXs ? 150 : isscreen600900 ? 200 : isMd ? 150 : undefined,
            renderCell: function (params) { return (_jsx(Box, { my: 1.5, display: 'flex', alignItems: 'center', gap: 2, children: _jsx(TableClickableItem, { text: params.row.documents, onClick: function () {
                        setSelectedMachineId(params.row.id);
                        setDocumentDialogOpen(true);
                    } }) })); }
        },
        {
            field: 'companyName',
            headerName: translate('common.company'),
            flex: 1.5,
            minWidth: isXs ? 150 : isscreen600900 ? 400 : isMd ? 150 : undefined,
            filterOperators: getFilteredStringOperators()
        },
        {
            field: 'action',
            headerName: '',
            align: 'right',
            sortable: false,
            filterable: false,
            disableColumnMenu: true,
            flex: isXs ? undefined : isscreen600900 ? undefined : isSm ? 1 : 1.5,
            minWidth: isXs ? 150 : isscreen600900 ? 150 : isMd ? 200 : undefined,
            width: isXs ? 200 : isMd ? 200 : isscreen600900 ? 200 : undefined,
            renderCell: function (params) { return (_jsxs(Box, { display: 'flex', flexShrink: 0, alignItems: 'center', justifyContent: 'flex-end', height: '100%', gap: 1, children: [_jsx(ProtectedElement, { permissions: [Permissions.Machines.Update], children: _jsx(Button, { variant: 'soft', size: 'small', onClick: function () { return handleOpenDialog(params.row); }, startIcon: _jsx(Unlink05Icon, {}), children: translate('common.link') }) }), _jsx(Button, { variant: 'soft', size: 'small', color: 'inherit', onClick: function () { return onManageSerialNumbers(params.row.id); }, children: translate('common.details') })] })); }
        }
    ];
    return (_jsxs(_Fragment, { children: [isXs || isIpadMini || isIpadMiniLandscape ? (_jsx(MachineLibraryCard, { isXs: isXs, isScreen9001200: iscreen9001200, isscreen600900Landscape: isscreen600900Landscape, isscreen600900: isscreen600900, iscreen9001200: iscreen9001200, isscreen9001200Landscape: isscreen9001200Landscape, isIpadMini: isIpadMini, isIpadMiniLandscape: isIpadMiniLandscape, openFilterDrawer: openFilterDrawer, isCompaniesFetching: isCompaniesFetching, isMachinesFetching: isMachinesFetching, isBrandsFetching: isBrandsFetching, isPaginatedMachinesLoading: isPaginatedMachinesLoading, machineOptions: machinesList, companyOptions: companiesList, brandOptions: machinesBrandList, isFetching: isPaginatedMachinesFetching, machineFilters: machineFilters, setMachineFilters: setMachineFilters, machineLibraryMachines: machines, control: control, errors: errors, handleSubmit: handleSubmit, reset: reset, onSearch: onSearch, setOpenFilterDrawer: setOpenFilterDrawer, handleOpenDialog: handleOpenDialog, onManageSerialNumbers: onManageSerialNumbers })) : (_jsx(MachineLibraryGrid, { isXs: isXs, isScreen9001200: iscreen9001200, isscreen600900Landscape: isscreen600900Landscape, isscreen600900: isscreen600900, iscreen9001200: iscreen9001200, isscreen9001200Landscape: isscreen9001200Landscape, isCompaniesFetching: isCompaniesFetching, isMachinesFetching: isMachinesFetching, isBrandsFetching: isBrandsFetching, isPaginatedMachinesLoading: isPaginatedMachinesLoading, machineOptions: machinesList, companyOptions: companiesList, brandOptions: machinesBrandList, machineFilters: machineFilters, rows: machines, columns: columns, rowCount: rowCount, openFilterDrawer: openFilterDrawer, control: control, errors: errors, filterModel: filterModel, onFilterModelChange: handleFilterModelChange, handleSubmit: handleSubmit, reset: reset, onSearch: onSearch, setOpenFilterDrawer: setOpenFilterDrawer, handleSortModelChange: handleSortModelChange, handlePaginationModelChange: handlePaginationModelChange })), _jsx(LinkToMachineDialog, { isOpen: dialogOpen, setIsOpen: setDialogOpen, selectedRow: selectedRow }), selectedMachineId && (_jsx(MachineLibraryDialog, { isOpen: documentDialogOpen, onClose: function () { return setDocumentDialogOpen(false); }, machineId: selectedMachineId }))] }));
};
export default MachineLibrary;
